"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ClipboardCheck, Megaphone, Key, FileChartColumn, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  title: "Onboarding",
  description: "We handle initial inspections, paperwork, and property setup to ensure your investment is ready for the market immediately.",
  icon: ClipboardCheck
}, {
  title: "Marketing",
  description: "Using professional photography and strategic listings, we attract high-quality tenants to minimize vacancy periods.",
  icon: Megaphone
}, {
  title: "Management",
  description: "From maintenance coordination to tenant relations, we handle the day-to-day operations with complete professionalism.",
  icon: Key
}, {
  title: "Reporting",
  description: "Receive transparent, detailed monthly financial reports so you can track your investment's performance effortlessly.",
  icon: FileChartColumn
}];
export default function YourInvestmentLifecycle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="your-investment-lifecycle" className="py-20 bg-background overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4">
        <div className={cn("text-center mb-16 transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-foreground mb-4">
            Your Investment Lifecycle
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            A seamless, end-to-end process designed to maximize your returns and minimize your stress.
          </p>
        </div>

        <div className="relative">
          {}
          <div className={cn("hidden md:block absolute top-[3.5rem] left-0 w-full h-[2px] bg-border -z-10 transition-all duration-1000 delay-300", isVisible ? "w-full opacity-100" : "w-0 opacity-0")} />
          
          {}
          <div className={cn("md:hidden absolute left-[2rem] top-0 h-full w-[2px] bg-border -z-10 transition-all duration-1000 delay-300", isVisible ? "h-full opacity-100" : "h-0 opacity-0")} />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6">
            {steps.map((step, i) => <div key={i} data-index={i} className={cn("relative flex md:flex-col items-start md:items-center gap-6 md:gap-8 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <div className="shrink-0 relative z-10">
                  <div className="flex items-center justify-center w-16 h-16 rounded-full bg-background border-2 border-primary/20 shadow-sm text-primary">
                    <step.icon className="w-7 h-7" />
                  </div>
                </div>

                {}
                <Card className="flex-1 w-full border-border/60 shadow-sm hover:shadow-md transition-shadow duration-300 bg-card/50 backdrop-blur-sm">
                  <CardHeader className="pb-2 md:text-center">
                    <div className="text-5xl font-serif font-bold text-primary/80 mb-2 leading-none">
                      0{i + 1}
                    </div>
                    <CardTitle className="text-xl font-semibold">{step.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="md:text-center">
                    <CardDescription className="text-base leading-relaxed">
                      {step.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>

        <div className={cn("mt-16 text-center transition-all duration-700 delay-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <Button asChild size="lg" className="rounded-full px-4 text-base">
            
          </Button>
        </div>
      </div>
    </section>;
}